import { createSlice} from '@reduxjs/toolkit';



const initialState = {
    notifications: [],
};

const notificationsSlice = createSlice({
    name: 'notification',
    initialState,
    reducers: {
        addSnackbar: (state, action) => {
            const key = action?.payload?.options?.key;
            state.notifications = [
                ...state.notifications,
                {
                    ...action.payload,
                    key: key,
                }];
        },
        closeSnackbar: (state, action) => {
            state.notifications = state.notifications.map(notification => (
                (action.payload.dismissAll || notification.options.key === action.payload.key)
                    ? {...notification, dismissed: true}
                    : {...notification}
            ))
        },
        removeSnackbar: (state, action) => {
            state.notifications = state.notifications.filter(
                notification => notification.key !== action.payload,
            )
        },
    },
});

export const { actions } = notificationsSlice;
export const { addSnackbar, closeSnackbar, removeSnackbar, ChangeNotification } = actions;

// selectors
export const selNotifications = (state) => state.notifications.notifications;



const reducer = {
    notifications: notificationsSlice.reducer,
};
export default reducer;